import { defineComponent as _defineComponent } from 'vue'
import debounce from "lodash/debounce";

import { onMounted, ref, watch } from "vue";

import globalHeader from "@/components/global-header/global-header.vue";
import globalFooter from "@/components/global-footer/global-footer.vue";
import TripAssigmentPopup from "@/components/trip-assigment-popup.vue";
import {headerHeight} from "@/components/global-header/headerState";
import navbarSlot from "@/components/Navbar/navbar-slot.vue";
import {navbarWidth} from '../components/Navbar/navState';
// import { useBookings } from "@/store/bookings";
import { useRoute } from "vue-router";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/util/firebase";
import BuilderMissingModal from "@/components/BuilderMissingModal.vue";
import { useBuilderStore } from "@/store/builder";
import { useAuth } from "@/store/auth";
import { FeatureFlags, useMittEvent } from '@busy-human/vue-component-library';
import emitter from '@/events';
import AdminPopup from "@/components/admin/admin-popup.vue";
import PromptHandler from "@/components/PromptHandler.vue";

const DOCUMENT_RESIZE_DEBOUNCE = 50;

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose: __expose }) {
  __expose();

if(process.env.NODE_ENV !== "production" || NODE_APP_INSTANCE === "staging") {
	// Maintenance shaft should not be used in production
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	const {useMaintenance} = require("@/util/maintenance");
	useMaintenance();
}

//const showGlobalHeader = CONFIG.flags.GLOBAL_HEADER;
//const showGlobalFooter = true //CONFIG.flags.GLOBAL_FOOTER;


// const bookings = useBookings();
// const userstate = useUserstate();
const builders = useBuilderStore();

onMounted(() => {
	(window as any).APPLICATION_LOADER.done();
});


const showAdminPanel = ref(false);
const showTripAssignmentPopup = ref(false);
const scrollingEnabled = ref(true);

const adminKeyEvent = (ev: KeyboardEvent) => {
	if(ev.key === '`') {
		showAdminPanel.value = !showAdminPanel.value;
	}
};

onAuthStateChanged(auth, (user) => {
	if(user) {
		const authstore = useAuth();
		if(authstore.isAdmin) {
			window.addEventListener('keyup', adminKeyEvent);
		} else {
			window.removeEventListener('keyup', adminKeyEvent);
		}
	}
});

const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
};
window.addEventListener(`resize`, debounce(documentHeight, DOCUMENT_RESIZE_DEBOUNCE));
documentHeight();

watch(()=> builders.selectableBuilders, selectable =>{
	if(selectable.length > 0){
		const hasShownPopup = sessionStorage.getItem("hasShownWelcomeBack");
		if(hasShownPopup !== 'true') {
			sessionStorage.setItem("hasShownWelcomeBack","true");
			showTripAssignmentPopup.value = !useRoute()?.meta?.dontShowPopup;
		}
	}
},{immediate: true});

const tripAssignmentMessage = ref<string>();
emitter.on("openWelcomeBack", (optionalText) => {
	if(optionalText){
		tripAssignmentMessage.value = optionalText;
	}
	showTripAssignmentPopup.value = !useRoute()?.meta?.dontShowPopup;
});

useMittEvent(emitter, "hideWelcomeBack", () => {
	showTripAssignmentPopup.value = false;
});

emitter.on("disableScrolling",()=>{
	scrollingEnabled.value = false;
	console.log("ON DISABLE SCROLLING", scrollingEnabled.value);
});

emitter.on("enableScrolling",()=>{
	scrollingEnabled.value = true;
	console.log("ON ENABLE SCROLLING", scrollingEnabled.value);
});

window.addEventListener('popstate', () => {
	scrollingEnabled.value = true;
});



//watch(()=> scrollingEnabled.value, ()=>{
//	console.log("SCROLLING????", scrollingEnabled.value);
//});



const __returned__ = { builders, showAdminPanel, showTripAssignmentPopup, scrollingEnabled, adminKeyEvent, documentHeight, DOCUMENT_RESIZE_DEBOUNCE, tripAssignmentMessage, get debounce() { return debounce }, onMounted, ref, watch, globalHeader, globalFooter, TripAssigmentPopup, get headerHeight() { return headerHeight }, navbarSlot, get navbarWidth() { return navbarWidth }, get useRoute() { return useRoute }, get onAuthStateChanged() { return onAuthStateChanged }, get auth() { return auth }, BuilderMissingModal, get useBuilderStore() { return useBuilderStore }, get useAuth() { return useAuth }, get FeatureFlags() { return FeatureFlags }, get useMittEvent() { return useMittEvent }, get emitter() { return emitter }, AdminPopup, PromptHandler }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})